import { css } from '@emotion/core'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { Link } from './Link'

interface ProductHeroCardProps {
  imageSrc: { gatsbyImageData: IGatsbyImageData }
  company: string
  companyLogo?: {
    file: { url: string }
  }
  name: string
  title: string
  slug: string
}
export const ProductHeroCard: React.FC<ProductHeroCardProps> = ({
  imageSrc,
  company,
  companyLogo,
  name,
  title,
  slug,
}) => {
  return (
    <Link
      css={css`
        position: relative;
        overflow: hidden;
        border-radius: 0.5rem;
        height: 29rem;
        /* width: 304px; */
        text-decoration: none;
        transition: all 0.175s ease;
        // temporary fix for Safari (overflow: hidden is disregarded otherwise)
        isolation: isolate;

        @media screen and (min-width: ${breakpoints.small}px) {
          height: 25rem;
        }

        @media screen and (min-width: ${breakpoints.large}px) {
          height: 22rem;
        }

        &:hover {
          box-shadow: 0 20px 30px -11px rgba(0, 0, 0, 0.26);
          [data-gradient] {
            opacity: 1;
          }
        }
      `}
      href={`/product-heroes/${slug}/`}
    >
      <div
        css={css`
          position: absolute;
          left: 0%;
          top: 0%;
          right: 0%;
          bottom: 0%;
          z-index: 0;
        `}
      >
        <GatsbyImage
          image={imageSrc.gatsbyImageData}
          alt={name}
          css={css`
            height: 100%;
            width: 100%;
          `}
        />
      </div>
      {/* initial gradient */}
      <div
        css={css`
          position: absolute;
          left: 0%;
          top: 0%;
          right: 0%;
          bottom: 0%;
          background: linear-gradient(180deg, rgba(196, 196, 196, 0) 25%, rgba(28, 35, 41, 0.75) 100%);
        `}
      />
      {/* hover gradient */}
      <div
        data-gradient
        css={css`
          position: absolute;
          left: 0%;
          top: 0%;
          right: 0%;
          bottom: 0%;
          z-index: 0;
          border-radius: 0.5rem;
          transition: all 0.175s ease;
          background: linear-gradient(180deg, transparent 25%, rgba(28, 35, 41, 0.75) 100%);
          opacity: 0%;
        `}
      />
      <div
        className="body-2 white-text"
        css={css`
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 1.5rem;
          @media screen and (max-width: ${breakpoints.medium}px) {
            padding: 0.5rem;
          }
        `}
      >
        <div
          css={css`
            max-height: 32px;
          `}
        >
          {companyLogo && (
            <img
              css={css`
                max-height: 32px;
                max-width: 112px;
              `}
              src={companyLogo?.file.url}
              alt={company}
            />
          )}
        </div>
        <div className="strong-body-1">{name}</div>
        <div className="body-2">{title}</div>
      </div>
    </Link>
  )
}
